module.exports = __webpack_public_path__ + "static/media/harts_bg1.9d934e19.jpg";